// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"36bac445","963":"b3ea0620"}[chunkId] + ".chunk.js";
};